import React from 'react';
import { Link } from 'react-router-dom';
import { People } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import { UserAccount } from '../../../domain/userAccount';
import { Group } from '../../../domain/group';

type UsersTableRowProps = {
    user: UserAccount;
    groups: Group[];
    onManageGroups: (user: UserAccount) => void;
}

export const UsersTableRow = ({ user, groups, onManageGroups }: UsersTableRowProps) => {
    const userGroups = groups.filter(g => user.groupIds?.includes(g.id));

    return (
        <tr>
            <td>
                <Link to={`/stats?creatorId=${user.sub}`} className="text-decoration-none">
                    {user.firstName} {user.lastname}
                </Link>
            </td>
            <td>{user.email}</td>
            <td>
                {userGroups.length > 0 
                    ? userGroups.map(g => g.name).join(', ') 
                    : <span className="text-muted">Brak grup</span>
                }
            </td>
            <td className="text-end">
                <Button variant="link" size="sm" className="p-0" onClick={() => onManageGroups(user)}>
                    <People /> Zarządzaj grupami
                </Button>
            </td>
        </tr>
    );
};
